module.exports = __webpack_public_path__ + "img/tb.a786a63e.png";